import React, { useState } from 'react';
import { Grid, Typography, withStyles } from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import PropTypes from 'prop-types';
import styles from './styles';
import MarketingDataModal from './general/MarketingDataModal';

const FIELDS = [
    { key: 'campaignName', label: 'Campaign Name' },
    { key: 'campaignSource', label: 'Campaign Source' },
    { key: 'campaignMedium', label: 'Campaign Medium' },
    { key: 'campaignTerm', label: 'Campaign Term' },
    { key: 'campaignContent', label: 'Campaign Content' },
    { key: 'referralSource', label: 'Marketing Source' },
    { key: 'firstPageVisited', label: 'First Page Visited' },
    { key: 'gclid', label: 'GCLID' },
    { key: 'pageEnquiredThrough', label: 'Page Enquired Through' }
];

function CustomerMarketingData({ customer, reloadCustomer, classes }) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <Grid container className={classes.infoCard} spacing={1}>
                <Grid item container direction="row">
                    <Grid item xs={12} justifyContent="center" alignContent="center">
                        <Typography align="center" variant="h4" className={classes.bold}>
                            Marketing Data <Edit onClick={() => setIsModalOpen(true)} />
                        </Typography>
                    </Grid>
                </Grid>
                {FIELDS.map(({ key, label }) => (
                    <Grid item container direction="row" key={key} className={classes.font14}>
                        <Grid item xs={6}>
                            {label}:
                        </Grid>
                        <Grid item xs={6}>
                            <Typography style={{ fontSize: 14 }}>
                                {customer && customer[key] ? customer[key] : ''}
                            </Typography>
                        </Grid>
                    </Grid>
                ))}
            </Grid>
            <MarketingDataModal
                open={isModalOpen}
                customer={customer}
                onClose={() => {
                    setIsModalOpen(false);
                    if (reloadCustomer) reloadCustomer(customer.id);
                }}
            />
        </>
    );
}

CustomerMarketingData.propTypes = {
    classes: PropTypes.object.isRequired,
    customer: PropTypes.object,
    reloadCustomer: PropTypes.func
};

export default withStyles(styles)(CustomerMarketingData);
